import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import NavigationBar from '../layout/NavigationBar';
import ActiveUsers from '../auth/ActiveUsers';
import { firestoreConnect } from 'react-redux-firebase';
import '../../css/Dashboard.css'

import Up from '../../res/up.svg';
import Down from '../../res/down.svg';        

import '../../style.scss';

class Dashboard extends Component {
  
    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    render() {
        const { auth } = this.props;

        if (!auth.uid) return <Redirect to="/welcome" />;
        
        let assets = 0;
        let prevAssets = 0;
        let assetDelta = 0;
        let assetDeltaFormatted = "";

        if(this.props.users) {
            for(const key in this.props.users) {
                if(this.props.users[key].id === auth.uid) {
                    assets = this.props.users[key].assets;
                    prevAssets = this.props.users[key].prevAssets;
                    break;
                }
            }
    
            assetDelta = 100 * (assets - prevAssets) / ((prevAssets + assets) / 2);
            
            assetDeltaFormatted = this.formatNumber(assetDelta.toFixed(2));
            assets = this.formatNumber(assets);
        }

        return (
            <div className={ 'darkDashboard' } >
                <NavigationBar activeTab="dashboard" />
                <div id="page-wrap" className="dashboard container">
                    <div className="action">
                        <div className="title">
                            <h2>Dashboard</h2>
                        </div>
                        <div className="metrics shares_only">
                            <h4><span className="money">${ assets }</span></h4>
                            <span className="deltaAssets">
                                <img src={(assetDelta < 0) ? Down : Up} alt="Price Delta" />
                                <span className={(assetDelta) < 0 ? 'down' : 'up'}>{ assetDeltaFormatted }%</span>
                            </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col s6 m6">
                        </div>
                        <div className="col s6 m6">
                            <ActiveUsers users={this.props.users} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        users: state.firestore.ordered.users,
    }    
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect(props => {
        return [
            { collection: 'users' },
            { collection: 'notifications', doc: props.auth.uid }]
    })
)(Dashboard);